import { twSpecList, cqSpecList } from "../config/twSpecList";
import { getQuery } from "lib";

export const slotImgFetch = ({
  html = "",
  game_id = "1",
  imagesdomain = "",
}) => {
  // replace key list

  const keySwitch = (val = "") => {
    switch (val) {
      case "WW":
      case "WILD":
        return "W";
      case "SF":
      case "SC":
      case "FREE GAME ICONS":
      case "SCATTER":
      case "symbol":
      case "symbol_F":
        return "F";
      case "SB":
      case "SBS":
        return "SBS";
      case "FREE":
      case "icons":
        return "icons";
      default:
        return val;
    }
  };
  const forReplace = () => {
    const lang = getQuery("language");
    const originGameId = getQuery("gameid");
    let updateHtml = html;
    if (html.split('<figure class="table">').length !== 1) {
      for (
        let i = 0;
        i < html.split('<figure class="table">').length - 1;
        i++
      ) {
        updateHtml = updateHtml.replace(
          `<figure class="table">`,
          `<figure class="table-ckeditor">`
        );
      }
    }
    const rule = new RegExp("(\\[).+?(\\])", "g");
    const replaceKeyList = html.match(rule);
    const newList = replaceKeyList?.map((v) => v.slice(1, -1));
    if (newList) {
      for (let i = 0; i < newList.length; i++) {
        const switchIcon = keySwitch(newList[i]);
        const resultUrl =
          switchIcon === "F" && twSpecList.indexOf(originGameId) !== -1
            ? `tw/${switchIcon}`
            : switchIcon === "W" && cqSpecList.indexOf(originGameId) !== -1
            ? `cq/${switchIcon}`
            : switchIcon;
        const getGameId = () => {
          if(originGameId === "VPCQS34" && lang === "id") {
            return "VPCQS34";
          }
          return game_id;
        }
        updateHtml = updateHtml.replace(
          `[${newList[i]}]`,
          `<img src="${imagesdomain}/vp_project/common/${getGameId()}/symbolList/${resultUrl}.png" alt="" />`
        );
      }
    }
    if (html.split("<p>#").length !== 1) {
      for (let i = 0; i < html.split("<p>#").length - 1; i++) {
        updateHtml = updateHtml.replace(`<p>#`, `<p class="indent">`);
      }
    }
    if (html.split("<p>!").length !== 1) {
      for (let i = 0; i < html.split("<p>!").length - 1; i++) {
        updateHtml = updateHtml.replace(`<p>!`, `<p class="img-text">`);
      }
    }
    if (html.split("<p>^").length !== 1) {
      for (let i = 0; i < html.split("<p>^").length - 1; i++) {
        updateHtml = updateHtml.replace(`<p>^`, `<p class="highlight">`);
      }
    }
    if (html.split("<p>@").length !== 1) {
      for (let i = 0; i < html.split("<p>@").length - 1; i++) {
        updateHtml = updateHtml.replace(`<p>@`, `<p class="no-dot">`);
      }
    }
    if (html.split("<p>$$$$").length !== 1) {
      for (let i = 0; i < html.split("<p>$$$$").length - 1; i++) {
        updateHtml = updateHtml.replace(
          `<p>$$$$`,
          `<p class="big_image no-dot">`
        );
      }
    }
    const contentDiv = document.createElement("div");
    contentDiv.innerHTML = updateHtml;
    const newDomList = [];
    contentDiv.childNodes.forEach((value, key) => {
      if (value.tagName === "P") {
        const newDom = [];
        value.childNodes.forEach((dom) => {
          if (dom.tagName === undefined) {
            const rule = new RegExp("\\d+X|\\d+x|\\d+", "g");
            const replaceString = dom.textContent.replace(
              rule,
              (str) => `<span class="number">${str}</span>`
            );
            newDom.push(replaceString);
          } else {
            newDom.push(dom.outerHTML);
          }
        });
        newDomList.push(`<p class="${value.className}">${newDom.join("")}</p>`);
      } else {
        newDomList.push(value.outerHTML);
      }
    });
    return newDomList.reduce((pre, value) => (pre || "") + (value || ""), "");
  };
  return forReplace();
};

// 替代代碼成圖片網址
export const createSymbol = (symbol, imagesdomain = "") => {
  let result = symbol;
  const rule = new RegExp("(\\[).+?(\\])", "g");
  const match = symbol.match(rule);
  const newList = match?.map((v) => v.slice(1, -1));
  if (newList) {
    for (let i = 0; i < match.length; i++) {
      result = result.replaceAll(
        `[${newList[i]}]`,
        `<img src="${imagesdomain}/help/common/currency/${newList[i]}.png" alt=""/> &nbsp;`
      );
    }
  }
  return { __html: result };
};
